import {useQuery} from "@tanstack/react-query";
import {AccountSearchInterface} from "../../list/interface/searchInterface";
import {readAccountlistApi} from "../../../../../api/correspondent/CorresspondentApi";

type Props = {
    searchData: AccountSearchInterface;
};

export const useReadAccountList = ({searchData}: Props) => {
    const {data} = useQuery({
        queryKey: ["readContactList", searchData],
        queryFn: async () => await readAccountlistApi({...searchData}),
        // staleTime: 10000 * 6,
    });

    return {data};
};
